export const translations = {
  fr: {
    nav: {
      cases: "Au quotidien",
      how: "Comment ça marche",
      usecases: "Cas d'usage",
      security: "Contrôle",
      faq: "Questions",
      cta: "Demander un accès privé",
    },
    hero: {
      badge: "Copilote opérationnel IA",
      title_l1: "Envoyez un message.",
      title_l2: "iko agit dans vos outils.",
      subtitle:
        "iko est un agent opérationnel connecté à vos outils de travail. Il retrouve les informations, prépare les décisions et exécute les tâches qui ralentissent vos journées.",
      cta_primary: "Demander un accès privé",
      cta_secondary: "Voir comment ça marche",
      pills: [
        { value: "20 min", text: "économisées sur le brief du matin", icon: "sunrise" },
        { value: "15 min", text: "gagnées avant un rendez-vous", icon: "calendar" },
        { value: "30 min", text: "récupérées après une réunion", icon: "file" },
        { value: "30 min", text: "économisées sur relances et suivis", icon: "bell" },
      ],
      pills_note:
        "Estimations variables selon les usages et les outils connectés.",
      tools_floating: ["Gmail", "CRM", "Calendar", "Drive"],
      phone: {
        header_status: "en ligne",
        header_title: "iko",
        user_msg: "Prépare mon call avec Nicolas demain.",
        ai_msg:
          "Je rassemble les derniers échanges, les documents liés et les points importants.",
        statuses: [
          "Emails analysés",
          "CRM consulté",
          "Documents retrouvés",
          "Questions préparées",
        ],
        result_title: "Brief prêt",
        result_body:
          "Historique résumé. Objections probables. Prochaine action recommandée.",
        result_meta: "",
        replay: "Rejouer",
      },
    },
    constat: {
      eyebrow: "Le constat",
      title_l1: "Vous avez déjà les outils.",
      title_l2: "Il manque le lien entre eux.",
      subtitle:
        "Emails, CRM, agenda, documents, messageries et logiciels métier : l'information existe déjà. Mais elle reste dispersée, obligeant les équipes à chercher, recopier, relancer et mettre à jour manuellement.",
      body: "",
      hero_phrase_l1: "Les logiciels stockent l'information. Les humains prennent les décisions.",
      hero_phrase_l2: "",
      hero_phrase_l3: "iko transforme l'information en action.",
      before_label: "Informations dispersées",
      after_label: "Action générée",
      tools: [
        { name: "Gmail", note: "dernier échange" },
        { name: "CRM", note: "opportunité ouverte" },
        { name: "Drive", note: "contrat v3" },
        { name: "Calendar", note: "call 15h" },
        { name: "Slack", note: "question en attente" },
        { name: "Facturation", note: "devis envoyé" },
      ],
      action_items: ["Synthèse prête", "Relance recommandée", "CRM mis à jour"],
      conversation: {
        user: "Où en est ce dossier ?",
        ai: "J'ai retrouvé les échanges, le devis, le contrat et la prochaine action.",
      },
    },
    how: {
      eyebrow: "Comment ça marche",
      title: "Tout commence par un message.",
      subtitle:
        "Connectez vos outils, choisissez où parler à iko, puis demandez-lui ce dont vous avez besoin.",
      steps: [
        {
          n: "01",
          title: "Connectez vos outils",
          body:
            "Reliez les outils importants pour qu'iko comprenne votre contexte, retrouve les bonnes informations et suive vos sujets.",
          kind: "tools",
        },
        {
          n: "02",
          title: "Parlez-lui où vous travaillez déjà",
          body:
            "WhatsApp, Telegram, Slack, Teams ou interface dédiée : iko reste disponible dans vos canaux habituels.",
          kind: "channels",
        },
        {
          n: "03",
          title: "Demandez simplement",
          body:
            "Préparer, retrouver, analyser, résumer, relancer, planifier ou suivre : iko comprend l'intention et mobilise les bons outils.",
          kind: "ask",
          ask: "Relance les prospects sans réponse depuis 30 jours.",
          ask_result: ["12 prospects trouvés", "Messages personnalisés", "Suivi programmé"],
        },
        {
          n: "04",
          title: "Validez quand c'est sensible",
          body:
            "Avant un envoi, une modification importante ou une action sensible, iko peut demander votre accord.",
          kind: "validate",
          validate_title: "Confirmer l'envoi des 12 relances ?",
          validate_summary: ["12 destinataires", "Messages personnalisés", "Suivi programmé"],
          validate_modify: "Modifier",
          validate_confirm: "Valider",
        },
      ],
    },
    integrations: {
      eyebrow: "Intégrations",
      title: "iko agit à travers les outils que vous utilisez déjà.",
      subtitle:
        "Vous ne remplacez pas vos outils. iko les relie pour retrouver l'information, exécuter les actions et garder le fil.",
      more: "Nouvelles intégrations ajoutées progressivement",
      micro: {
        Gmail: "retrouve les échanges",
        CRM: "met à jour les opportunités",
        Calendar: "prépare les rendez-vous",
        Drive: "analyse les documents",
        Slack: "résume les conversations",
      },
    },
    day: {
      eyebrow: "Au quotidien",
      title: "Du brief du matin au suivi du soir.",
      subtitle:
        "iko intervient aux moments où le travail se bloque : préparer, retrouver, résumer, relancer, analyser et suivre.",
      moments: [
        {
          time: "06:00",
          title: "Brief automatique",
          body:
            "Avant même de commencer, iko rassemble vos rendez-vous, emails importants, chiffres clés, relances, échéances et priorités.",
        },
        {
          time: "08:30",
          title: "Préparer un rendez-vous",
          body:
            "Avant un rendez-vous, iko retrouve le contexte, l'historique, les documents utiles, les questions et les objections probables.",
        },
        {
          time: "10:00",
          title: "Retrouver les chiffres",
          body:
            "iko rassemble les données utiles sans ouvrir vos tableaux, CRM ou outils internes.",
        },
        {
          time: "11:30",
          title: "Relancer",
          body:
            "iko identifie les prospects, devis ou factures à relancer, rédige les messages et programme le suivi.",
        },
        {
          time: "15:00",
          title: "Après réunion",
          body:
            "Après un Meet ou Teams, iko transforme l'échange en compte-rendu, tâches, mise à jour CRM et email de suivi.",
        },
        {
          time: "18:30",
          title: "Clôturer",
          body:
            "iko résume ce qui a avancé, ce qui bloque, les engagements pris et les priorités du lendemain.",
        },
      ],
      scripts: [
        {
          user: null,
          ai: "Bonjour. Votre journée est prête.",
          statuses: ["Agenda consolidé", "Priorités identifiées", "Urgences détectées"],
          result_title: "Brief du matin",
          result_body:
            "3 priorités · 2 rendez-vous sensibles · 4 relances · 1 facture à suivre.",
        },
        {
          user: "Prépare mon call avec Nicolas.",
          ai: "Je rassemble l'historique, les points sensibles et les questions prioritaires.",
          statuses: ["Historique retrouvé", "Documents analysés", "Questions préparées"],
          result_title: "Brief prêt",
          result_body:
            "Historique · Points sensibles · Questions prioritaires · Prochaine action recommandée.",
        },
        {
          user: "Quels sont les chiffres commerciaux de la semaine ?",
          ai: "Je consolide les données du CRM, des tableurs et des outils internes.",
          statuses: ["CRM consulté", "Tableurs lus", "Données croisées"],
          result_title: "Chiffres de la semaine",
          result_body:
            "24 leads · 8 RDV pris · 3 devis envoyés · 2 relances en retard · Pipe estimé : 18 400 €.",
        },
        {
          user: "Relance les prospects silencieux depuis 30 jours.",
          ai: "J'identifie les prospects, rédige les messages adaptés et programme le suivi.",
          statuses: ["Prospects détectés", "Messages personnalisés", "Suivi programmé"],
          result_title: "Relances prêtes",
          result_body:
            "12 prospects trouvés. Messages prêts à valider. Suivi programmé sous 7 jours.",
        },
        {
          user: null,
          ai: "Réunion analysée.",
          statuses: ["Compte-rendu prêt", "4 tâches créées", "CRM mis à jour", "Email de suivi prêt"],
          result_title: "Suivi de réunion",
          result_body:
            "Compte-rendu, tâches et email de suivi générés. CRM synchronisé.",
        },
        {
          user: "Prépare demain.",
          ai: "Je consolide la journée et les priorités du lendemain.",
          statuses: ["Journée résumée", "Engagements listés", "Priorités classées"],
          result_title: "Plan de demain",
          result_body:
            "Demain : 2 rendez-vous à préparer · 1 devis à relancer · 3 tâches bloquées. Priorité : finaliser la proposition.",
        },
      ],
      footer_title: "iko devient un réflexe quotidien.",
      footer_body:
        "Pas une démo ponctuelle. Un copilote présent aux moments où le travail se bloque.",
      footer_stats: ["Continuité", "Moins d'interruptions", "Moins de charge mentale"],
    },
    usecases: {
      eyebrow: "Cas d'usage",
      title: "Une demande peut déclencher plusieurs actions.",
      subtitle:
        "iko comprend le contexte, retrouve les informations utiles, puis prépare ou exécute ce qui doit avancer.",
      items: [
        {
          kind: "prepare",
          name: "Préparer",
          ask: "Prépare mon rendez-vous.",
          actions: ["Historique retrouvé", "Documents analysés", "Questions préparées"],
          badge: "Brief prêt",
        },
        {
          kind: "retrieve",
          name: "Retrouver",
          ask: "Où en est ce dossier ?",
          actions: ["Emails analysés", "Documents retrouvés", "Décisions extraites"],
          badge: "Synthèse prête",
        },
        {
          kind: "summarize",
          name: "Résumer",
          ask: "Résume cette réunion.",
          actions: ["Décisions identifiées", "Tâches créées", "Prochaines étapes listées"],
          badge: "Compte-rendu prêt",
        },
        {
          kind: "follow_up",
          name: "Relancer",
          ask: "Relance les prospects sans réponse.",
          actions: ["Prospects détectés", "Messages personnalisés", "Suivi programmé"],
          badge: "À valider",
        },
        {
          kind: "analyze",
          name: "Analyser",
          ask: "Analyse ce marché.",
          actions: ["Sources analysées", "Concurrents comparés", "Opportunités identifiées"],
          badge: "Recommandation prête",
        },
        {
          kind: "track",
          name: "Suivre",
          ask: "N'oublie pas cet engagement.",
          actions: ["Échéance enregistrée", "Responsable identifié", "Alerte programmée"],
          badge: "Suivi actif",
        },
      ],
    },
    security: {
      eyebrow: "Toujours sous contrôle",
      title_l1: "iko agit.",
      title_l2: "Vous décidez.",
      subtitle:
        "Vous choisissez les outils connectés, les permissions accordées et le niveau d'autonomie de chaque action.",
      permissions_columns: ["Outil", "Lecture", "Brouillon", "Modification", "Envoi"],
      permissions_matrix: [
        { tool: "Gmail", states: ["on", "on", "off", "validate"] },
        { tool: "CRM", states: ["on", "off", "validate", "validate"] },
        { tool: "Agenda", states: ["on", "validate", "validate", "off"] },
        { tool: "Drive", states: ["scoped", "off", "off", "off"] },
        { tool: "Facturation", states: ["on", "off", "off", "off"] },
      ],
      legend: {
        on: "Activée",
        off: "—",
        validate: "Validation",
        scoped: "Périmètre",
      },
      validation_title: "Validation requise",
      validation_body: "iko souhaite envoyer 12 relances.",
      validation_modify: "Modifier",
      validation_confirm: "Valider",
      points: [
        {
          title: "Permissions par outil",
          body: "Vous décidez ce qu'iko peut lire, modifier ou envoyer.",
        },
        {
          title: "Validation avant action",
          body: "Les actions sensibles restent soumises à votre accord.",
        },
        {
          title: "Traçabilité complète",
          body: "Chaque action peut être historisée et vérifiée.",
        },
      ],
      hero_phrase_l1: "iko n'oublie jamais.",
      hero_phrase_l2: "Mais il ne fait rien de sensible sans votre accord.",
    },
    testimonials: {
      eyebrow: "Exemples d'usage",
      title: "Les équipes l'utilisent quand le travail s'accumule.",
      subtitle:
        "Avant un rendez-vous, après une réunion ou quand une information manque, iko transforme le contexte en action.",
      items: [
        {
          when: "Avant un rendez-vous",
          ask: "Prépare mon rendez-vous.",
          actions: ["Historique retrouvé", "Documents analysés", "Questions préparées"],
          badge: "Brief prêt",
        },
        {
          when: "Après une réunion",
          ask: "Résume la réunion et prépare le suivi.",
          actions: ["Compte-rendu généré", "Tâches créées", "CRM mis à jour", "Email prêt"],
          badge: "Suivi prêt",
        },
        {
          when: "Quand une information manque",
          ask: "Où en est ce dossier ?",
          actions: ["Emails retrouvés", "Fichiers liés", "Décisions extraites", "Prochaine action"],
          badge: "Synthèse prête",
        },
      ],
    },
    faq: {
      eyebrow: "Questions",
      title: "Les bonnes questions.",
      items: [
        {
          q: "Concrètement, qu'est-ce qu'iko peut faire ?",
          a: "Préparer un brief, retrouver une information, résumer une réunion, relancer des prospects, analyser un marché, suivre un engagement, mettre à jour un outil. Toujours à travers vos outils existants.",
        },
        {
          q: "Comment iko agit dans mes outils ?",
          a: "Via des connecteurs officiels et sécurisés. iko ne stocke pas vos identifiants. Vous gardez la main sur ce qui est connecté et sur le niveau d'accès accordé.",
        },
        {
          q: "Dois-je tout valider à chaque fois ?",
          a: "Non. Vous configurez le niveau d'autonomie par type d'action. Les actions sensibles restent soumises à validation.",
        },
        {
          q: "Puis-je connecter mes outils internes ?",
          a: "Oui. De nouvelles intégrations sont ajoutées régulièrement. Notre équipe peut aussi étudier votre stack interne.",
        },
        {
          q: "Où je parle avec iko ?",
          a: "WhatsApp, Telegram, Slack, Teams ou une interface dédiée. Par message écrit ou note vocale.",
        },
        {
          q: "Comment se passe l'accès ?",
          a: "Accès privé, ouverture progressive. Vous demandez votre place, nous revenons rapidement avec les étapes d'installation.",
        },
      ],
    },
    waitlist: {
      eyebrow: "Accès privé",
      title: "Commencez avec un simple message.",
      subtitle:
        "Demandez un accès privé et découvrez comment iko peut s'intégrer à vos outils, vos canaux et vos priorités.",
      side_title_l1: "Vos outils sont déjà là.",
      side_title_l2: "iko les fait travailler ensemble.",
      side_body:
        "Reliez vos outils, choisissez vos canaux, définissez vos permissions, puis déléguez les micro-tâches qui prennent du temps.",
      placeholder_email: "Email",
      placeholder_first_name: "Prénom",
      channel_label: "Où souhaitez-vous utiliser iko ?",
      channels: ["WhatsApp", "Telegram", "Slack", "Teams"],
      tools_label: "Nombre d'outils utilisés au quotidien",
      tools_options: ["1-3", "4-6", "7+"],
      cta: "Demander un accès privé",
      microcopy: "Ouverture progressive des accès",
      success_title: "C'est noté.",
      success_body: "On revient vers vous rapidement avec les étapes d'installation.",
      error: "Email invalide. Réessayez.",
      error_server: "Envoi impossible pour le moment. Réessayez dans un instant.",
    },
    footer: {
      tagline: "Demandez à iko. Vos outils s'exécutent.",
      rights: "Tous droits réservés.",
      columns: [
        {
          title: "iko",
          links: [
            { label: "Au quotidien", href: "/#usecases" },
            { label: "Comment ça marche", href: "/#how" },
            { label: "Cas d'usage", href: "/#cases-grid" },
            { label: "Contrôle", href: "/#security" },
            { label: "Questions", href: "/#faq" },
            { label: "Accès privé", href: "/#waitlist" },
          ],
        },
        {
          title: "Plus",
          links: [
            { label: "Mentions légales", href: "#" },
            { label: "Confidentialité", to: "/confidentialite" },
            { label: "Contact", href: "mailto:contact@lumiron.ai" },
          ],
        },
      ],
      made: "Pensé et construit à Paris",
    },
  },
  en: {
    nav: {
      cases: "Day-to-day",
      how: "How it works",
      usecases: "Use cases",
      security: "Control",
      faq: "Questions",
      cta: "Get private access",
    },
    hero: {
      badge: "AI operational copilot",
      title_l1: "Send a message.",
      title_l2: "iko acts inside your tools.",
      subtitle:
        "iko is an operational agent plugged into your work tools. He finds the info, preps your decisions and runs the tasks that slow your day down.",
      cta_primary: "Get private access",
      cta_secondary: "See how it works",
      pills: [
        { value: "20 min", text: "saved on the morning brief", icon: "sunrise" },
        { value: "15 min", text: "gained before a meeting", icon: "calendar" },
        { value: "30 min", text: "back after a meeting", icon: "file" },
        { value: "30 min", text: "saved on follow-ups & tracking", icon: "bell" },
      ],
      pills_note:
        "Indicative estimates depending on usage and connected tools.",
      tools_floating: ["Gmail", "CRM", "Calendar", "Drive"],
      phone: {
        header_status: "online",
        header_title: "iko",
        user_msg: "Prep my call with Nicolas tomorrow.",
        ai_msg: "Pulling recent threads, related docs and the key points worth covering.",
        statuses: ["Emails parsed", "CRM checked", "Docs found", "Questions ready"],
        result_title: "Brief ready",
        result_body:
          "History summarized. Likely objections. Suggested next move.",
        result_meta: "",
        replay: "Replay",
      },
    },
    constat: {
      eyebrow: "The reality",
      title_l1: "You've already got the tools.",
      title_l2: "What's missing is the link between them.",
      subtitle:
        "Emails, CRM, calendar, docs, chats and internal software — the info is already there. But it stays scattered, forcing teams to search, copy-paste, follow up and update by hand.",
      body: "",
      hero_phrase_l1: "Software stores information. Humans make decisions.",
      hero_phrase_l2: "",
      hero_phrase_l3: "iko turns information into action.",
      before_label: "Scattered information",
      after_label: "Action generated",
      tools: [
        { name: "Gmail", note: "latest thread" },
        { name: "CRM", note: "open opportunity" },
        { name: "Drive", note: "contract v3" },
        { name: "Calendar", note: "3pm call" },
        { name: "Slack", note: "open question" },
        { name: "Billing", note: "quote sent" },
      ],
      action_items: ["Summary ready", "Follow-up recommended", "CRM updated"],
      conversation: {
        user: "Where is this deal at?",
        ai: "I pulled the threads, the quote, the contract and the next action.",
      },
    },
    how: {
      eyebrow: "How it works",
      title: "It all starts with a message.",
      subtitle:
        "Plug in your tools, pick where you want to chat with iko, then ask him for what you need.",
      steps: [
        {
          n: "01",
          title: "Plug in your tools",
          body:
            "Connect the tools that matter so iko gets your context, pulls the right info, and keeps up with what you're working on.",
          kind: "tools",
        },
        {
          n: "02",
          title: "Chat where you already work",
          body:
            "WhatsApp, Telegram, Slack, Teams or our own interface — iko shows up where you already are.",
          kind: "channels",
        },
        {
          n: "03",
          title: "Just ask",
          body:
            "Prep, find, analyze, summarize, follow up, plan or track — iko gets the intent and pulls the right tools together.",
          kind: "ask",
          ask: "Follow up with leads who've gone quiet for 30 days.",
          ask_result: ["12 leads found", "Tailored messages", "Follow-up scheduled"],
        },
        {
          n: "04",
          title: "Sign off when it matters",
          body:
            "Before a send, an important change or a sensitive action, iko can ask you first.",
          kind: "validate",
          validate_title: "Send the 12 follow-ups?",
          validate_summary: ["12 recipients", "Tailored messages", "Follow-up scheduled"],
          validate_modify: "Edit",
          validate_confirm: "Send",
        },
      ],
    },
    integrations: {
      eyebrow: "Integrations",
      title: "iko works through the tools you already use.",
      subtitle:
        "You're not replacing your stack. iko ties it together to find info, run actions and keep the thread.",
      more: "New integrations landing regularly",
      micro: {
        Gmail: "finds the threads",
        CRM: "updates the opportunities",
        Calendar: "preps the meetings",
        Drive: "parses the documents",
        Slack: "summarizes the conversations",
      },
    },
    day: {
      eyebrow: "Day-to-day",
      title: "From morning brief to evening wrap-up.",
      subtitle:
        "iko steps in at the moments where work gets stuck: prep, find, summarize, follow up, analyze and track.",
      moments: [
        {
          time: "6:00 AM",
          title: "Auto brief",
          body:
            "Before you even start, iko pulls together your meetings, key emails, numbers, follow-ups, deadlines and priorities.",
        },
        {
          time: "8:30 AM",
          title: "Prep a meeting",
          body:
            "Before a meeting, iko pulls the context, the history, the right docs, the questions and likely objections.",
        },
        {
          time: "10:00 AM",
          title: "Find the numbers",
          body:
            "iko surfaces the right data without you opening spreadsheets, CRM or internal tools.",
        },
        {
          time: "11:30 AM",
          title: "Follow up",
          body:
            "iko spots leads, quotes or invoices to follow up on, drafts the messages and schedules the next touch.",
        },
        {
          time: "3:00 PM",
          title: "After the meeting",
          body:
            "After a Meet or Teams call, iko turns it into a recap, tasks, CRM updates and a follow-up email.",
        },
        {
          time: "6:30 PM",
          title: "Wrap up",
          body:
            "iko sums up what moved, what's stuck, the commitments made and tomorrow's priorities.",
        },
      ],
      scripts: [
        {
          user: null,
          ai: "Morning. Your day's ready.",
          statuses: ["Calendar lined up", "Priorities mapped", "Urgent stuff flagged"],
          result_title: "Morning brief",
          result_body:
            "3 priorities · 2 sensitive meetings · 4 follow-ups · 1 invoice to track.",
        },
        {
          user: "Prep my call with Nicolas.",
          ai: "Pulling the history, the sensitive bits and the priority questions.",
          statuses: ["History found", "Docs parsed", "Questions ready"],
          result_title: "Brief ready",
          result_body:
            "History · Sensitive topics · Priority questions · Suggested next move.",
        },
        {
          user: "What are the sales numbers for this week?",
          ai: "Consolidating data from the CRM, spreadsheets and internal tools.",
          statuses: ["CRM checked", "Sheets parsed", "Data cross-referenced"],
          result_title: "Weekly numbers",
          result_body:
            "24 leads · 8 meetings booked · 3 quotes sent · 2 follow-ups overdue · Pipe est.: €18,400.",
        },
        {
          user: "Follow up the leads who've gone quiet for 30 days.",
          ai: "Spotting the leads, drafting tailored messages and scheduling the next touch.",
          statuses: ["Leads spotted", "Messages drafted", "Follow-up scheduled"],
          result_title: "Follow-ups ready",
          result_body:
            "12 leads found. Messages ready to send. Follow-up scheduled in 7 days.",
        },
        {
          user: null,
          ai: "Meeting parsed.",
          statuses: ["Recap ready", "4 tasks created", "CRM updated", "Follow-up email ready"],
          result_title: "Meeting follow-up",
          result_body:
            "Recap, tasks and follow-up email generated. CRM synced.",
        },
        {
          user: "Prep tomorrow.",
          ai: "Consolidating today's day and tomorrow's priorities.",
          statuses: ["Day summarized", "Commitments listed", "Priorities ranked"],
          result_title: "Tomorrow's plan",
          result_body:
            "Tomorrow: 2 meetings to prep · 1 quote to chase · 3 blocked tasks. Priority: finalize the proposal.",
        },
      ],
      footer_title: "iko becomes a daily reflex.",
      footer_body:
        "Not a one-off demo. A copilot that shows up at the moments where work gets stuck.",
      footer_stats: ["Continuity", "Fewer interruptions", "Less mental load"],
    },
    usecases: {
      eyebrow: "Use cases",
      title: "One ask can trigger several actions.",
      subtitle:
        "iko gets the context, finds the useful info, then preps or runs what needs to move.",
      items: [
        {
          kind: "prepare",
          name: "Prep",
          ask: "Prep my meeting.",
          actions: ["History found", "Docs parsed", "Questions ready"],
          badge: "Brief ready",
        },
        {
          kind: "retrieve",
          name: "Find",
          ask: "Where is this deal at?",
          actions: ["Emails parsed", "Docs found", "Decisions extracted"],
          badge: "Summary ready",
        },
        {
          kind: "summarize",
          name: "Summarize",
          ask: "Sum up this meeting.",
          actions: ["Decisions captured", "Tasks created", "Next steps listed"],
          badge: "Recap ready",
        },
        {
          kind: "follow_up",
          name: "Follow up",
          ask: "Chase the leads who haven't replied.",
          actions: ["Leads spotted", "Messages tailored", "Follow-up scheduled"],
          badge: "To approve",
        },
        {
          kind: "analyze",
          name: "Analyze",
          ask: "Analyze this market.",
          actions: ["Sources parsed", "Competitors compared", "Opportunities spotted"],
          badge: "Recommendation ready",
        },
        {
          kind: "track",
          name: "Track",
          ask: "Don't let this commitment slip.",
          actions: ["Deadline saved", "Owner identified", "Alert scheduled"],
          badge: "Active tracking",
        },
      ],
    },
    security: {
      eyebrow: "Always in control",
      title_l1: "iko acts.",
      title_l2: "You decide.",
      subtitle:
        "You pick the connected tools, the granted permissions and how much autonomy each action gets.",
      permissions_columns: ["Tool", "Read", "Draft", "Edit", "Send"],
      permissions_matrix: [
        { tool: "Gmail", states: ["on", "on", "off", "validate"] },
        { tool: "CRM", states: ["on", "off", "validate", "validate"] },
        { tool: "Calendar", states: ["on", "validate", "validate", "off"] },
        { tool: "Drive", states: ["scoped", "off", "off", "off"] },
        { tool: "Billing", states: ["on", "off", "off", "off"] },
      ],
      legend: { on: "On", off: "—", validate: "Approval", scoped: "Scoped" },
      validation_title: "Approval needed",
      validation_body: "iko wants to send 12 follow-ups.",
      validation_modify: "Edit",
      validation_confirm: "Send",
      points: [
        { title: "Per-tool permissions", body: "You decide what iko can read, edit or send." },
        { title: "Approval before action", body: "Sensitive actions stay gated by you." },
        { title: "Full audit trail", body: "Every action can be logged and verified." },
      ],
      hero_phrase_l1: "iko never forgets.",
      hero_phrase_l2: "But he doesn't do anything sensitive without your sign-off.",
    },
    testimonials: {
      eyebrow: "Real-world uses",
      title: "Teams use it when the work piles up.",
      subtitle:
        "Before a meeting, after a meeting or when info is missing, iko turns context into action.",
      items: [
        {
          when: "Before a meeting",
          ask: "Prep my meeting.",
          actions: ["History found", "Docs parsed", "Questions ready"],
          badge: "Brief ready",
        },
        {
          when: "After a meeting",
          ask: "Sum up the meeting and prep the follow-up.",
          actions: ["Recap generated", "Tasks created", "CRM updated", "Email ready"],
          badge: "Follow-up ready",
        },
        {
          when: "When info is missing",
          ask: "Where is this deal at?",
          actions: ["Emails found", "Files linked", "Decisions extracted", "Next action"],
          badge: "Summary ready",
        },
      ],
    },
    faq: {
      eyebrow: "Questions",
      title: "The right questions.",
      items: [
        {
          q: "Concretely, what can iko do?",
          a: "Prep a brief, find info, summarize a meeting, chase leads, analyze a market, track a commitment, update a tool — all through your existing stack.",
        },
        {
          q: "How does iko act inside my tools?",
          a: "Through official, secure connectors. iko doesn't store credentials. You stay in charge of what's connected and the access level granted.",
        },
        {
          q: "Do I have to approve everything?",
          a: "Nope. You set the autonomy level per action type. Sensitive actions stay gated by you.",
        },
        {
          q: "Can I plug in our internal tools?",
          a: "Yes. New integrations land regularly. Our team can also look at your in-house stack with you.",
        },
        {
          q: "Where do I talk to iko?",
          a: "WhatsApp, Telegram, Slack, Teams or our own interface. Written messages or voice notes.",
        },
        {
          q: "How does access work?",
          a: "Private access, gradual rollout. Ask for your spot and we get back to you quickly with how to set up.",
        },
      ],
    },
    waitlist: {
      eyebrow: "Private access",
      title: "Start with a simple message.",
      subtitle:
        "Get private access and see how iko fits into your tools, your habits and your priorities.",
      side_title_l1: "Your tools are already there.",
      side_title_l2: "iko makes them work together.",
      side_body:
        "Connect your tools, pick your channels, set your permissions, then start delegating the micro-tasks.",
      placeholder_email: "Email",
      placeholder_first_name: "First name",
      channel_label: "Where would you use iko?",
      channels: ["WhatsApp", "Telegram", "Slack", "Teams"],
      tools_label: "How many tools do you use daily?",
      tools_options: ["1-3", "4-6", "7+"],
      cta: "Get private access",
      microcopy: "Access rolling out gradually",
      success_title: "You're in.",
      success_body: "We'll get back to you soon with the setup steps.",
      error: "Email's not quite right. Try again.",
      error_server: "Couldn't send right now. Try again in a moment.",
    },
    footer: {
      tagline: "Just ask iko. Your tools run.",
      rights: "All rights reserved.",
      columns: [
        {
          title: "iko",
          links: [
            { label: "Day-to-day", href: "/#usecases" },
            { label: "How it works", href: "/#how" },
            { label: "Use cases", href: "/#cases-grid" },
            { label: "Control", href: "/#security" },
            { label: "Questions", href: "/#faq" },
            { label: "Private access", href: "/#waitlist" },
          ],
        },
        {
          title: "More",
          links: [
            { label: "Legal", href: "#" },
            { label: "Privacy", to: "/confidentialite" },
            { label: "Contact", href: "mailto:contact@lumiron.ai" },
          ],
        },
      ],
      made: "Designed and built in Paris",
    },
  },
};
